import { Type } from "@angular/core";
import { BasicHeaderComponent } from "@modules/+new/shared/universal-modal/components/_headers/basic/basic-header.component";
import { DefaultHeaderComponent } from "./default/default-header.component";

type ModalHeadersComponentTypes = BasicHeaderComponent | DefaultHeaderComponent;
export enum ModalHeadersEnum {
	basic = "basic",
	twoSided = "twoSided"
}

export const ModalHeadersIndex: Record<ModalHeadersEnum, Type<ModalHeadersComponentTypes>> = {
	[ModalHeadersEnum.basic]: BasicHeaderComponent,
	[ModalHeadersEnum.twoSided]: DefaultHeaderComponent
};
